<template>
  <div
    class="star-box sentinel-box"
    tabindex="0"
  >
    <button
      v-for="(icon, index) in ratingsIcon"
      :key="icon.id"
      class="star-btn tab-focused-btn"
      :aria-label="`${icon.id} star`"
      aria-pressed="false"
      :disabled="disabled"
      @click="(event) => onRatingClick(event, index)"
    >
      <div
        class="ratings"
        :class="{'ratings-selected': selected, 'ratings-btn-disabled': disabled, 'ratings-filled': icon.val !== ICONS.STAR}"
      >
        <BaseIcon
          :name="icon.val"
          height="32px"
          width="32px"
          :fill="getFillColor(icon.val)"
        />
      </div>
    </button>
  </div>
</template>
<script>
import BaseIcon from '@/views/BaseIcon.vue';
import { ICONS, COLORS } from '../../constant'

const DEFAULT_RATING = [
  { id: '1', val: ICONS.STAR },
  { id: '2', val: ICONS.STAR },
  { id: '3', val: ICONS.STAR },
  { id: '4', val: ICONS.STAR },
  { id: '5', val: ICONS.STAR },
]

export default {
  name: 'StarRating',
  components: {
    BaseIcon
  },
  props: {
    ratingChanged: {
      type: Function,
      default: () => {}
    },
    schema: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ratingsIcon: DEFAULT_RATING
    }
  },
  watch: {
    schema() {
      this.ratingsIcon = DEFAULT_RATING
    }
  },
  created() {
    this.ICONS = ICONS
  },
  methods: {
    onRatingClick(event, index) {
      this.ratingsIcon = this.ratingsIcon.map((ele, i) => {
        return (i <= index) ? { id: ele.id, val: ICONS.STAR_FILLED } : { id: ele.id, val: ICONS.STAR }
      })
      let node = event.target
      while (node?.tagName !== 'BUTTON') node = node?.parentNode
      if (node) node.attributes['aria-pressed'].nodeValue = true
      this.ratingChanged(index + 1)
    },
    getFillColor(icon) {
      return (icon === ICONS.STAR) ? COLORS.STAR : COLORS.STAR_FILLED
    }
  }
}
</script>
<style lang="scss" scoped>
  .star-box {
    display: flex;
    gap: 32px;
    .star-btn {
      .ratings {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        height: 48px;
        width: 48px;
        background-color: #FAFAFA;
        align-content: center;
        border-radius: 8px; 
        &.ratings-btn-disabled {
          cursor: not-allowed;
        }
        &.ratings-selected {
          border: 1px solid#CDCDCD;
          background: #FFF;
        }
        &:not(.ratings-filled) {
          border: none;
        }
      }
    }
  }
</style>
